import PropTypes from "prop-types";
import React, { useState, useEffect, useRef } from "react";
import { connect } from "react-redux";

import { MSpinner } from "components/Shared";
import MCaseView from "containers/Homeowner/MCaseView";
import { getCubiCasaSketch } from "requests/homeowner/caseforms";
import { getAvailableExports } from 'requests/caseExports';

const SummaryView = (props) => {
  const mounted = useRef(true);
  const [sections, setSections] = useState([]);
  const [cubiCasa, setCubiCasa] = useState(null);
  const [availableExports, setAvailableExports] = useState([]);

  const {
    qaCase,
    summaryViewEnabled,
    caseSketch,
    controlIdNumber,
  } = props;

  useEffect(() => {
    getSections();
    getCubiCasaSketch(controlIdNumber, (data) => {
      setCubiCasa(data);
    }, () => {}, mounted); 
    getAvailableExports(controlIdNumber, (resp) => {
      setAvailableExports(resp ? resp.availableExportCodes : []);
    }, () => {}, mounted);   
  }, []);

  useEffect(() => {
    getSections(); 
  }, [controlIdNumber, caseSketch]);

  const getSections = () => {
    let _sections = []; 
    _sections.push(
      {
        title: `Order Information`,
        id: "Header",
        formStatus: "clean",
      },
      {
        title: `History`,
        id: "History",
        formStatus: "clean",
      });
    if (caseSketch) {
      _sections.push({
        title: `Phoenix Sketch`,
        id: "Sketch",
        formStatus: "clean",
      });
    }
    if(cubiCasa) {
      _sections.push({
        title: `CubiCasa`,
        id: "CubiCasa",
        formStatus: "clean",
        external: true,
      });     
    }
    _sections.push(
      {
        title: `Photos`,
        id: "Photos",
        formStatus: "clean",
      },
      {
        title: `File Manager`,
        id: "Files",
        formStatus: "clean",
      },
      {
        title: `UCDP Submittal`,
        id: "UcdpSubmittal",
        formStatus: "clean",
      },
    );

    if(availableExports.length){
      _sections.push({
        title: "Exports",
        id: "Exports", 
        formStatus: "clean",
      });
    }
    _sections.push({
      title: `Case Actions`,
      id: "Validation",
      formStatus: "clean",
    }),    
    setSections(_sections);
  };

  if (!qaCase.caseInfo) return (<MSpinner />);

  return (
    <div style={{ display: summaryViewEnabled ? "flex" : "none", height: "100%" }}>
      <MCaseView
        externalFormSet={sections.length ? sections : getSections()}
        controlNumberOverride={controlIdNumber}
        firstChildInitialSize={"40%"}
        forcePushToPane={["Files"]}
        qaTouches={qaCase?.caseInfo?.qaTouches ?? []}
      />
    </div>
  );
};

SummaryView.propTypes = {
  controlIdNumber: PropTypes.number.isRequired,
  qaCase: PropTypes.object.isRequired,
  summaryViewEnabled: PropTypes.bool.isRequired,
  viewSwitchBlocked: PropTypes.bool.isRequired,
  value360: PropTypes.object.isRequired,
  caseSketch: PropTypes.object,
};

const mapStateToProps = state => {
  return {
    summaryViewEnabled: state.qualityAssurance.qaVariables.summaryViewEnabled,
    value360: state.qualityAssurance.value360,
    qaCase: state.qualityAssurance.qaCase,
    caseSketch: state.qualityAssurance.qaCase.caseSketch,
    controlIdNumber: state.qualityAssurance.qaCase.controlIdNumber,   
  };
};

export default connect(mapStateToProps, null)(SummaryView);
